import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { LoginForm } from '../../features/users';
import {
  WatercraftAuthLayout,
  WatercraftHelmet,
} from '../../features/watercraft';
import { WATERCRAFT_SUBMIT_BUTTON_CLASS } from '../../features/watercraft/styles';
import { WATERCRAFT_ROUTE } from '../../app/appConstants';
import { WATERCRAFT_ACCOUNT_CREATION_ROUTE } from './constants';

export default function WatercraftLoginPage(): React.JSX.Element {
  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get('redirect');
  const redirectUrl = redirectParam ?? WATERCRAFT_ROUTE;
  const createAccountLink = redirectParam
    ? `${WATERCRAFT_ACCOUNT_CREATION_ROUTE}?redirect=${encodeURIComponent(
        redirectParam
      )}`
    : WATERCRAFT_ACCOUNT_CREATION_ROUTE;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <WatercraftHelmet />
      <WatercraftAuthLayout
        heading='Welcome back'
        subheading='Enter your login details below'
      >
        <LoginForm
          redirectUrl={redirectUrl}
          submitClassName={WATERCRAFT_SUBMIT_BUTTON_CLASS}
        />
        <p className='text-sm font-medium text-watercraft-text-secondary'>
          Don&apos;t have an account?{' '}
          <Link
            to={createAccountLink}
            className='font-semibold text-watercraft-accent underline'
          >
            Create one
          </Link>
        </p>
      </WatercraftAuthLayout>
    </>
  );
}
